import { api } from "./api";

export const obtenerMultaPorPrestamo = async (idPrestamo) => {
  const { data } = await api.get("/multas/obtenerPorPrestamo", {
    params: { idPrestamo },
  });
  return data;
};

export const desactivarMultaPorPrestamo = async (idPrestamo, idPersonalRecepcion) => {
  const { data } = await api.put(`/multas/desactivarPorPrestamo/${idPrestamo}`, null, {
    params: { idPersonalRecepcion },
  });
  return data;
};
